module.exports = __webpack_public_path__ + "r-v3/img/set_share.e247f712.svg";